var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isFullDineIn)?_c('i',_vm._g({staticClass:"iconfont dm-reload",class:['refresh', { refreshing: _setup.props.refreshing }]},_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }